var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExtend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.79 18.24c0-.47.38-.85.85-.85h8.67a.85.85 0 1 1 0 1.7h-8.67a.85.85 0 0 1-.85-.85"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.039 14.969a.85.85 0 0 1 1.202 0l2.67 2.67a.85.85 0 0 1-1.202 1.202l-2.67-2.67a.85.85 0 0 1 0-1.202"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.911 17.639a.85.85 0 0 1 0 1.202l-2.67 2.67a.85.85 0 1 1-1.202-1.202l2.67-2.67a.85.85 0 0 1 1.202 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.55 6.21c-.58 0-1.05.47-1.05 1.05v11.75c0 .58.47 1.05 1.05 1.05h4.54a.85.85 0 0 1 0 1.7H4.55a2.75 2.75 0 0 1-2.75-2.75V7.26a2.75 2.75 0 0 1 2.75-2.75h14.87a2.75 2.75 0 0 1 2.75 2.75v6.01a.85.85 0 1 1-1.7 0V7.26c0-.58-.47-1.05-1.05-1.05z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.8 10.57c0-.47.38-.85.85-.85h18.66a.85.85 0 1 1 0 1.7H2.65a.85.85 0 0 1-.85-.85"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.69 2c.47 0 .85.38.85.85v5.14a.85.85 0 0 1-1.7 0V2.85c0-.47.38-.85.85-.85"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.27 2c.47 0 .85.38.85.85v5.14a.85.85 0 1 1-1.7 0V2.85c0-.47.38-.85.85-.85"
}))));
export default SvgExtend;